module.exports = __webpack_public_path__ + "img/surfWhite.40cae757.svg";